module.exports = __webpack_public_path__ + "img/mail-icon.2575f23c.svg";